import React, {
    useMemo,
    useState,
  } from "react";
  
  import {
    Link,
    Navigate,
  } from "react-router-dom";
  
  import {
    useDispatch,
    useSelector,
  } from "react-redux";
  
  import {
    useTranslation,
  } from "react-i18next";
  
  import {
    motion,
    AnimatePresence,
  } from "framer-motion";
  
  import {
    Header,
    Fotter,
  } from "../components/layout";
  
  import {
    useStateContext,
  } from "../context/ContextProvider";
  
  import {
    clearOrder,
  } from "../redux/actions/order";
  
  import {
    media,
  } from "../server";
  
  import {
    FiUser,
    FiPhone,
    FiMapPin,
    FiShoppingBag,
    FiArrowLeft,
    FiArrowRight,
    FiEdit3,
    FiCheck,
    FiChevronLeft,
    FiChevronRight,
    FiHome,
    FiHash,
    FiTruck,
  } from "react-icons/fi";
  
  import {
    FaWhatsapp,
    FaUtensils,
  } from "react-icons/fa";
  
  
  const WHATSAPP_NUMBER = "201080608050";
  
  
  function Checkout() {
    const { t } = useTranslation();
  
    const dispatch = useDispatch();
  
    const {
      currentDir,
    } = useStateContext();
  
    const isRTL =
      currentDir === "rtl";
  
  
    /* =====================================
        ORDER
    ====================================== */
  
    const items = useSelector(
      (state) =>
        state.Order?.items || []
    );
  
  
    /* =====================================
        ORDER TYPE
  
        inside  = داخل المطعم
        outside = توصيل
    ====================================== */
  
    const [
      orderType,
      setOrderType,
    ] = useState("outside");
  
  
    /* =====================================
        CUSTOMER DATA
    ====================================== */
  
    const [
      customer,
      setCustomer,
    ] = useState({
      name: "",
      phone: "",
      address: "",
      tableNumber: "",
    });
  
  
    const [
      errors,
      setErrors,
    ] = useState({});
  
  
    const [
      isSubmitting,
      setIsSubmitting,
    ] = useState(false);
  
  
    /* =====================================
        DIRECTIONS
    ====================================== */
  
    const DirectionArrow =
      isRTL
        ? FiArrowLeft
        : FiArrowRight;
  
  
    const BreadcrumbArrow =
      isRTL
        ? FiChevronLeft
        : FiChevronRight;
  
  
    /* =====================================
        TOTAL QUANTITY
    ====================================== */
  
    const totalQuantity =
      useMemo(() => {
        return items.reduce(
          (total, item) =>
            total +
            Number(
              item.quantity || 0
            ),
          0
        );
      }, [items]);
  
  
    /* =====================================
        ORDER TOTAL
    ====================================== */
  
    const orderTotal =
      useMemo(() => {
        return items.reduce(
          (total, item) => {
  
            const price =
              Number(
                item.price || 0
              );
  
            const quantity =
              Number(
                item.quantity || 1
              );
  
            return (
              total +
              price * quantity
            );
          },
          0
        );
      }, [items]);
  
  
    /* =====================================
        CHANGE ORDER TYPE
    ====================================== */
  
    const handleOrderTypeChange =
      (type) => {
  
        setOrderType(type);
  
        /*
         * حذف الأخطاء القديمة
         * عند تغيير نوع الطلب
         */
        setErrors({});
      };
  
  
    /* =====================================
        INPUT CHANGE
    ====================================== */
  
    const handleChange = (
      event
    ) => {
  
      const {
        name,
        value,
      } = event.target;
  
  
      setCustomer(
        (prev) => ({
          ...prev,
          [name]: value,
        })
      );
  
  
      if (errors[name]) {
        setErrors(
          (prev) => ({
            ...prev,
            [name]: "",
          })
        );
      }
    };
  
  
    /* =====================================
        VALIDATION
    ====================================== */
  
    const validate = () => {
  
      const newErrors = {};
  
  
      /*
       * داخل المطعم
       */
  
      if (
        orderType === "inside"
      ) {
  
        if (
          !customer.tableNumber
            .trim()
        ) {
          newErrors.tableNumber =
            t(
              "table number is required"
            );
        }
  
      }
  
  
      /*
       * خارج المطعم
       */
  
      if (
        orderType === "outside"
      ) {
  
        /* Name */
  
        if (
          !customer.name.trim()
        ) {
          newErrors.name =
            t(
              "name is required"
            );
        } else if (
          customer.name
            .trim()
            .length < 2
        ) {
          newErrors.name =
            t(
              "enter valid name"
            );
        }
  
  
        /* Phone */
  
        if (
          !customer.phone.trim()
        ) {
          newErrors.phone =
            t(
              "phone is required"
            );
        } else {
  
          const normalizedPhone =
            customer.phone.replace(
              /[\s()-]/g,
              ""
            );
  
          const phoneRegex =
            /^\+?[0-9]{7,15}$/;
  
  
          if (
            !phoneRegex.test(
              normalizedPhone
            )
          ) {
            newErrors.phone =
              t(
                "invalid phone number"
              );
          }
        }
  
  
        /* Address */
  
        if (
          !customer.address.trim()
        ) {
          newErrors.address =
            t(
              "address is required"
            );
        } else if (
          customer.address
            .trim()
            .length < 5
        ) {
          newErrors.address =
            t(
              "enter detailed address"
            );
        }
  
      }
  
  
      setErrors(
        newErrors
      );
  
  
      return (
        Object.keys(
          newErrors
        ).length === 0
      );
    };
  
  
    /* =====================================
        WHATSAPP MESSAGE
    ====================================== */
  
    const buildWhatsAppMessage =
      () => {
  
        const mealsText =
          items.map(
            (
              item,
              index
            ) => {
  
              const title =
                item?.titleAr ||
                item?.titleEn ||
                "وجبة";
  
  
              const quantity =
                Number(
                  item.quantity || 1
                );
  
  
              const price =
                Number(
                  item.price || 0
                );
  
  
              const itemTotal =
                quantity *
                price;
  
  
              const lines = [
                `*${index + 1}. ${title}*`,
                `الكمية: ${quantity}`,
                `سعر الوحدة: ${price} جنيه`,
                `الإجمالي: ${itemTotal} جنيه`,
              ];
  
  
              if (
                item?.notes &&
                item.notes.trim()
              ) {
                lines.push(
                  `ملاحظات: ${item.notes.trim()}`
                );
              }
  
  
              return lines.join(
                "\n"
              );
            }
          );
  
  
        /*
         * بيانات الطلب
         * حسب داخل / خارج
         */
  
        let customerSection;
  
  
        if (
          orderType === "inside"
        ) {
  
          customerSection = [
            "🍽️ *نوع الطلب: داخل المطعم*",
            "",
            `🪑 رقم الطاولة: ${customer.tableNumber.trim()}`,
          ];
  
        } else {
  
          customerSection = [
            "🛵 *نوع الطلب: توصيل خارج المطعم*",
            "",
            "👤 *بيانات العميل*",
            `الاسم: ${customer.name.trim()}`,
            `رقم الهاتف: ${customer.phone.trim()}`,
            `عنوان التوصيل: ${customer.address.trim()}`,
          ];
  
        }
  
  
        return [
          "🍽️ *طلب جديد من مطعم يمان*",
  
          "",
          "━━━━━━━━━━━━━━",
          "",
  
          ...customerSection,
  
          "",
          "━━━━━━━━━━━━━━",
          "",
  
          "🛍️ *تفاصيل الطلب*",
          "",
  
          mealsText.join(
            "\n\n"
          ),
  
          "",
          "━━━━━━━━━━━━━━",
          "",
  
          `إجمالي الكمية: ${totalQuantity}`,
          `*إجمالي الطلب: ${orderTotal} جنيه*`,
  
          "",
          "━━━━━━━━━━━━━━",
          "",
  
          "تم إرسال الطلب من موقع مطعم يمان.",
        ].join("\n");
      };
  
  
    /* =====================================
        COMPLETE ORDER
    ====================================== */
  
    const handleSubmit = (
      event
    ) => {
  
      event.preventDefault();
  
  
      if (isSubmitting) {
        return;
      }
  
  
      if (!validate()) {
        return;
      }
  
  
      if (!items.length) {
        return;
      }
  
  
      setIsSubmitting(true);
  
  
      /*
       * أولًا إنشاء الرسالة
       */
  
      const message =
        buildWhatsAppMessage();
  
  
      /*
       * إنشاء رابط واتساب
       */
  
      const whatsappUrl =
        `https://wa.me/${WHATSAPP_NUMBER}` +
        `?text=${encodeURIComponent(
          message
        )}`;
  
  
      /*
       * حذف الطلب
       * من Redux + localStorage
       */
  
      dispatch(
        clearOrder()
      );
  
  
      /*
       * فتح WhatsApp
       */
  
      window.location.href =
        whatsappUrl;
    };
  
  
    /* =====================================
        EMPTY ORDER
    ====================================== */
  
    if (
      items.length === 0 &&
      !isSubmitting
    ) {
      return (
        <Navigate
          to="/AllResturentMeals"
          replace
        />
      );
    }
  
  
    return (
      <>
        <Header />
  
  
        <main
          className="
            relative
  
            min-h-screen
  
            overflow-hidden
  
            bg-back-secondary
            dark:bg-back-darkprimery
  
            pt-32
            md:pt-40
  
            pb-20
            md:pb-28
          "
        >
  
          {/* Background */}
  
          <div
            className="
              absolute
  
              -top-44
              -end-44
  
              w-[440px]
              h-[440px]
  
              rounded-full
  
              bg-color-1/10
  
              blur-[120px]
  
              pointer-events-none
            "
          />
  
  
          <div
            className="
              absolute
  
              -bottom-40
              -start-40
  
              w-[380px]
              h-[380px]
  
              rounded-full
  
              border
              border-color-1/10
  
              pointer-events-none
            "
          />
  
  
          <div
            className="
              container
  
              relative
              z-10
            "
          >
  
            {/* =================================
                BREADCRUMB
            ================================= */}
  
            <motion.div
              initial={{
                opacity: 0,
                y: 15,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              className="
                flex
                flex-wrap
  
                items-center
  
                gap-2
  
                mb-8
  
                font-kufi
                text-xs
  
                text-n-5
                dark:text-tcolor-3
              "
            >
  
              <Link
                to="/"
                className="
                  hover:text-color-1
                  transition-colors
                "
              >
                {t("home")}
              </Link>
  
  
              <BreadcrumbArrow
                size={13}
              />
  
  
              <span
                className="
                  text-color-1
                "
              >
                {t(
                  "complete order"
                )}
              </span>
  
            </motion.div>
  
  
            {/* =================================
                PAGE TITLE
            ================================= */}
  
            <motion.div
              initial={{
                opacity: 0,
                y: 25,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              className="
                max-w-3xl
  
                mb-10
                md:mb-14
              "
            >
  
              <div
                className="
                  flex
                  items-center
  
                  gap-3
  
                  mb-4
                "
              >
                <span
                  className="
                    w-12
                    h-[2px]
  
                    bg-color-1
                  "
                />
  
  
                <FiShoppingBag
                  className="
                    text-color-1
                  "
                />
  
  
                <span
                  className="
                    font-kufi
                    text-sm
  
                    text-color-1
                  "
                >
                  {t(
                    "complete your order"
                  )}
                </span>
              </div>
  
  
              <h1
                className="
                  font-kufi
                  font-bold
  
                  text-3xl
                  md:text-5xl
  
                  text-tcolor-4
                  dark:text-tcolor-1
  
                  mb-5
                "
              >
                {t(
                  "how would you like your order"
                )}
              </h1>
  
  
              <p
                className="
                  max-w-2xl
  
                  font-kufi
  
                  text-sm
                  md:text-base
  
                  text-n-6
                  dark:text-tcolor-2
  
                  leading-8
                "
              >
                {t(
                  "choose dine in or delivery and complete the required information"
                )}
              </p>
  
            </motion.div>
  
  
            {/* =================================
                LAYOUT
            ================================= */}
  
            <div
              className="
                grid
  
                lg:grid-cols-[minmax(0,1fr)_420px]
  
                gap-7
                lg:gap-12
  
                items-start
              "
            >
  
              {/* =================================
                  LEFT
              ================================= */}
  
              <motion.form
                initial={{
                  opacity: 0,
                  y: 25,
                }}
                animate={{
                  opacity: 1,
                  y: 0,
                }}
                onSubmit={
                  handleSubmit
                }
                noValidate
                className="
                  rounded-[1.75rem]
                  md:rounded-[2rem]
  
                  border
                  border-color-2/10
                  dark:border-white/10
  
                  bg-back-primery
                  dark:bg-back-darksecondary
  
                  p-5
                  md:p-8
  
                  shadow-[0_12px_40px_rgba(68,37,20,0.07)]
                "
              >
  
                {/* =================================
                    ORDER TYPE
                ================================= */}
  
                <div
                  className="
                    mb-8
                  "
                >
                  <div
                    className="
                      mb-5
                    "
                  >
                    <span
                      className="
                        block
  
                        font-kufi
                        text-xs
  
                        text-color-1
  
                        mb-1
                      "
                    >
                      {t(
                        "order location"
                      )}
                    </span>
  
  
                    <h2
                      className="
                        font-kufi
                        font-semibold
  
                        text-xl
                        md:text-2xl
  
                        text-tcolor-4
                        dark:text-white
                      "
                    >
                      {t(
                        "where would you like to receive your order"
                      )}
                    </h2>
                  </div>
  
  
                  <div
                    className="
                      grid
                      grid-cols-2
  
                      gap-3
                      md:gap-4
                    "
                  >
  
                    {/* INSIDE */}
  
                    <button
                      type="button"
  
                      onClick={() =>
                        handleOrderTypeChange(
                          "inside"
                        )
                      }
  
                      className={`
                        relative
  
                        overflow-hidden
  
                        rounded-[1.5rem]
  
                        border
  
                        p-4
                        md:p-5
  
                        text-start
  
                        transition-all
                        duration-300
  
                        ${
                          orderType ===
                          "inside"
                            ? `
                              border-color-1
                              bg-color-1/10
  
                              shadow-[0_10px_30px_rgba(165,119,58,0.12)]
                            `
                            : `
                              border-color-2/10
                              dark:border-white/10
  
                              bg-back-secondary
                              dark:bg-back-darkprimery
  
                              hover:border-color-1/40
                            `
                        }
                      `}
                    >
  
                      <div
                        className={`
                          flex
  
                          w-12
                          h-12
  
                          items-center
                          justify-center
  
                          rounded-2xl
  
                          mb-4
  
                          ${
                            orderType ===
                              "inside"
                              ? `
                                bg-color-1
                                text-white
                              `
                              : `
                                bg-color-1/10
                                text-color-1
                              `
                          }
                        `}
                      >
                        <FiHome
                          size={20}
                        />
                      </div>
  
  
                      <h3
                        className="
                          font-kufi
                          font-semibold
  
                          text-sm
                          md:text-base
  
                          text-tcolor-4
                          dark:text-white
                        "
                      >
                        {t(
                          "dine in"
                        )}
                      </h3>
  
  
                      <p
                        className="
                          hidden
                          sm:block
  
                          mt-1
  
                          font-kufi
                          text-xs
  
                          text-n-5
                          dark:text-tcolor-3
                        "
                      >
                        {t(
                          "order to your table"
                        )}
                      </p>
  
  
                      {orderType ===
                        "inside" && (
  
                        <div
                          className="
                            absolute
  
                            top-4
                            end-4
  
                            flex
  
                            w-6
                            h-6
  
                            items-center
                            justify-center
  
                            rounded-full
  
                            bg-color-1
  
                            text-white
                            text-xs
                          "
                        >
                          <FiCheck />
                        </div>
  
                      )}
  
                    </button>
  
  
                    {/* OUTSIDE */}
  
                    <button
                      type="button"
  
                      onClick={() =>
                        handleOrderTypeChange(
                          "outside"
                        )
                      }
  
                      className={`
                        relative
  
                        overflow-hidden
  
                        rounded-[1.5rem]
  
                        border
  
                        p-4
                        md:p-5
  
                        text-start
  
                        transition-all
                        duration-300
  
                        ${
                          orderType ===
                          "outside"
                            ? `
                              border-color-1
                              bg-color-1/10
  
                              shadow-[0_10px_30px_rgba(165,119,58,0.12)]
                            `
                            : `
                              border-color-2/10
                              dark:border-white/10
  
                              bg-back-secondary
                              dark:bg-back-darkprimery
  
                              hover:border-color-1/40
                            `
                        }
                      `}
                    >
  
                      <div
                        className={`
                          flex
  
                          w-12
                          h-12
  
                          items-center
                          justify-center
  
                          rounded-2xl
  
                          mb-4
  
                          ${
                            orderType ===
                              "outside"
                              ? `
                                bg-color-1
                                text-white
                              `
                              : `
                                bg-color-1/10
                                text-color-1
                              `
                          }
                        `}
                      >
                        <FiTruck
                          size={20}
                        />
                      </div>
  
  
                      <h3
                        className="
                          font-kufi
                          font-semibold
  
                          text-sm
                          md:text-base
  
                          text-tcolor-4
                          dark:text-white
                        "
                      >
                        {t(
                          "delivery"
                        )}
                      </h3>
  
  
                      <p
                        className="
                          hidden
                          sm:block
  
                          mt-1
  
                          font-kufi
                          text-xs
  
                          text-n-5
                          dark:text-tcolor-3
                        "
                      >
                        {t(
                          "delivery to your address"
                        )}
                      </p>
  
  
                      {orderType ===
                        "outside" && (
  
                        <div
                          className="
                            absolute
  
                            top-4
                            end-4
  
                            flex
  
                            w-6
                            h-6
  
                            items-center
                            justify-center
  
                            rounded-full
  
                            bg-color-1
  
                            text-white
                            text-xs
                          "
                        >
                          <FiCheck />
                        </div>
  
                      )}
  
                    </button>
  
                  </div>
  
                </div>
  
  
                {/* Divider */}
  
                <div
                  className="
                    h-px
                    w-full
  
                    bg-color-2/10
                    dark:bg-white/10
  
                    mb-8
                  "
                />
  
  
                {/* =================================
                    CONDITIONAL FORM
                ================================= */}
  
                <AnimatePresence
                  mode="wait"
                >
  
                  {/* =============================
                      INSIDE
                  ============================== */}
  
                  {orderType ===
                    "inside" && (
  
                    <motion.div
                      key="inside"
  
                      initial={{
                        opacity: 0,
                        y: 15,
                      }}
  
                      animate={{
                        opacity: 1,
                        y: 0,
                      }}
  
                      exit={{
                        opacity: 0,
                        y: -10,
                      }}
                    >
  
                      <div
                        className="
                          flex
                          items-center
  
                          gap-4
  
                          mb-7
                        "
                      >
                        <div
                          className="
                            flex
  
                            w-12
                            h-12
  
                            items-center
                            justify-center
  
                            rounded-2xl
  
                            bg-color-1/10
  
                            text-color-1
                          "
                        >
                          <FiHash />
                        </div>
  
  
                        <div>
                          <h2
                            className="
                              font-kufi
                              font-semibold
  
                              text-lg
                              md:text-xl
  
                              text-tcolor-4
                              dark:text-white
                            "
                          >
                            {t(
                              "table information"
                            )}
                          </h2>
  
  
                          <p
                            className="
                              font-kufi
                              text-xs
  
                              text-n-5
                              dark:text-tcolor-3
  
                              mt-1
                            "
                          >
                            {t(
                              "enter the table number shown on your table"
                            )}
                          </p>
                        </div>
  
                      </div>
  
  
                      <CheckoutInput
                        icon={
                          FiHash
                        }
  
                        label={t(
                          "table number"
                        )}
  
                        name="tableNumber"
  
                        type="text"
  
                        inputMode="numeric"
  
                        value={
                          customer.tableNumber
                        }
  
                        onChange={
                          handleChange
                        }
  
                        placeholder={t(
                          "enter table number"
                        )}
  
                        error={
                          errors.tableNumber
                        }
                      />
  
                    </motion.div>
  
                  )}
  
  
                  {/* =============================
                      OUTSIDE
                  ============================== */}
  
                  {orderType ===
                    "outside" && (
  
                    <motion.div
                      key="outside"
  
                      initial={{
                        opacity: 0,
                        y: 15,
                      }}
  
                      animate={{
                        opacity: 1,
                        y: 0,
                      }}
  
                      exit={{
                        opacity: 0,
                        y: -10,
                      }}
                    >
  
                      <div
                        className="
                          flex
                          items-center
  
                          gap-4
  
                          mb-7
                        "
                      >
                        <div
                          className="
                            flex
  
                            w-12
                            h-12
  
                            items-center
                            justify-center
  
                            rounded-2xl
  
                            bg-color-1/10
  
                            text-color-1
                          "
                        >
                          <FiUser />
                        </div>
  
  
                        <div>
                          <h2
                            className="
                              font-kufi
                              font-semibold
  
                              text-lg
                              md:text-xl
  
                              text-tcolor-4
                              dark:text-white
                            "
                          >
                            {t(
                              "delivery information"
                            )}
                          </h2>
  
  
                          <p
                            className="
                              font-kufi
                              text-xs
  
                              text-n-5
                              dark:text-tcolor-3
  
                              mt-1
                            "
                          >
                            {t(
                              "required delivery information"
                            )}
                          </p>
                        </div>
  
                      </div>
  
  
                      <CheckoutInput
                        icon={
                          FiUser
                        }
  
                        label={t(
                          "customer name"
                        )}
  
                        name="name"
  
                        value={
                          customer.name
                        }
  
                        onChange={
                          handleChange
                        }
  
                        placeholder={t(
                          "enter your name"
                        )}
  
                        error={
                          errors.name
                        }
  
                        autoComplete="name"
                      />
  
  
                      <CheckoutInput
                        icon={
                          FiPhone
                        }
  
                        label={t(
                          "phone number"
                        )}
  
                        name="phone"
  
                        type="tel"
  
                        dir="ltr"
  
                        value={
                          customer.phone
                        }
  
                        onChange={
                          handleChange
                        }
  
                        placeholder={t(
                          "enter phone number"
                        )}
  
                        error={
                          errors.phone
                        }
  
                        autoComplete="tel"
  
                        inputMode="tel"
                      />
  
  
                      <CheckoutInput
                        icon={
                          FiMapPin
                        }
  
                        label={t(
                          "delivery address"
                        )}
  
                        name="address"
  
                        value={
                          customer.address
                        }
  
                        onChange={
                          handleChange
                        }
  
                        placeholder={t(
                          "enter delivery address"
                        )}
  
                        error={
                          errors.address
                        }
  
                        autoComplete="street-address"
                      />
  
                    </motion.div>
  
                  )}
  
                </AnimatePresence>
  
  
                {/* =================================
                    WHATSAPP INFO
                ================================= */}
  
                <div
                  className="
                    flex
                    items-start
  
                    gap-3
  
                    rounded-[1.25rem]
  
                    bg-color-1/10
  
                    p-4
  
                    mt-2
                    mb-7
                  "
                >
  
                  <FaWhatsapp
                    className="
                      shrink-0
  
                      text-color-1
                      text-xl
  
                      mt-1
                    "
                  />
  
  
                  <p
                    className="
                      font-kufi
                      text-xs
                      md:text-sm
  
                      text-tcolor-4
                      dark:text-white/70
  
                      leading-7
                    "
                  >
                    {orderType ===
                    "inside"
                      ? t(
                          "inside whatsapp checkout notice"
                        )
                      : t(
                          "whatsapp checkout notice"
                        )}
                  </p>
  
                </div>
  
  
                {/* =================================
                    SUBMIT
                ================================= */}
  
                <motion.button
                  type="submit"
  
                  whileTap={
                    !isSubmitting
                      ? {
                          scale:
                            0.98,
                        }
                      : {}
                  }
  
                  disabled={
                    isSubmitting
                  }
  
                  className="
                    group
  
                    flex
  
                    w-full
  
                    min-h-[58px]
  
                    items-center
                    justify-center
  
                    gap-3
  
                    rounded-full
  
                    bg-color-1
  
                    px-6
                    py-4
  
                    font-kufi
                    font-semibold
  
                    text-white
  
                    shadow-[0_14px_40px_rgba(165,119,58,0.25)]
  
                    transition-all
                    duration-300
  
                    hover:bg-color-2
  
                    disabled:opacity-70
                  "
                >
  
                  <FaWhatsapp
                    size={20}
                  />
  
  
                  <span>
                    {isSubmitting
                      ? t(
                          "opening whatsapp"
                        )
                      : t(
                          "complete order on whatsapp"
                        )}
                  </span>
  
  
                  {!isSubmitting && (
                    <DirectionArrow />
                  )}
  
                </motion.button>
  
              </motion.form>
  
  
              {/* =================================
                  ORDER SUMMARY
              ================================= */}
  
              <motion.aside
                initial={{
                  opacity: 0,
                  y: 25,
                }}
                animate={{
                  opacity: 1,
                  y: 0,
                }}
                className="
                  lg:sticky
                  lg:top-28
                "
              >
  
                <div
                  className="
                    relative
  
                    overflow-hidden
  
                    rounded-[1.75rem]
                    md:rounded-[2rem]
  
                    bg-color-2
  
                    p-5
                    md:p-6
  
                    text-white
  
                    shadow-[0_20px_60px_rgba(68,37,20,0.20)]
                  "
                >
  
                  {/* Glow */}
  
                  <div
                    className="
                      absolute
  
                      -top-24
                      -end-24
  
                      w-52
                      h-52
  
                      rounded-full
  
                      bg-color-1/15
  
                      blur-[70px]
                    "
                  />
  
  
                  <div
                    className="
                      relative
                      z-10
                    "
                  >
  
                    {/* Header */}
  
                    <div
                      className="
                        flex
                        items-center
                        justify-between
  
                        gap-4
  
                        pb-5
                        mb-5
  
                        border-b
                        border-white/10
                      "
                    >
  
                      <div
                        className="
                          flex
                          items-center
                          gap-3
                        "
                      >
                        <div
                          className="
                            flex
  
                            w-11
                            h-11
  
                            items-center
                            justify-center
  
                            rounded-xl
  
                            bg-color-1
                          "
                        >
                          <FiShoppingBag />
                        </div>
  
  
                        <div>
                          <h2
                            className="
                              font-kufi
                              font-semibold
  
                              text-lg
                            "
                          >
                            {t(
                              "order summary"
                            )}
                          </h2>
  
  
                          <span
                            className="
                              font-kufi
                              text-[10px]
  
                              text-white/50
                            "
                          >
                            {totalQuantity}{" "}
                            {t(
                              "items"
                            )}
                          </span>
                        </div>
  
                      </div>
  
  
                      {/* Order Type */}
  
                      <span
                        className="
                          rounded-full
  
                          bg-white/10
  
                          px-3
                          py-2
  
                          font-kufi
                          text-[10px]
  
                          text-color-1
                        "
                      >
                        {orderType ===
                        "inside"
                          ? t(
                              "dine in"
                            )
                          : t(
                              "delivery"
                            )}
                      </span>
  
                    </div>
  
  
                    {/* ITEMS */}
  
                    <div
                      className="
                        space-y-4
                      "
                    >
  
                      {items.map(
                        (item) => {
  
                          const title =
                            isRTL
                              ? item.titleAr ||
                                item.titleEn
                              : item.titleEn ||
                                item.titleAr;
  
  
                          const quantity =
                            Number(
                              item.quantity ||
                                1
                            );
  
  
                          const price =
                            Number(
                              item.price ||
                                0
                            );
  
  
                          const lineTotal =
                            quantity *
                            price;
  
  
                          return (
                            <div
                              key={
                                item.lineId
                              }
  
                              className="
                                pb-4
  
                                border-b
                                border-white/10
  
                                last:border-b-0
                              "
                            >
  
                              <div
                                className="
                                  flex
                                  gap-3
                                "
                              >
  
                                <div
                                  className="
                                    w-16
                                    h-16
  
                                    shrink-0
  
                                    overflow-hidden
  
                                    rounded-xl
  
                                    bg-white/5
                                  "
                                >
  
                                  {item.Image ? (
  
                                    <img
                                      src={`${media}${item.Image}`}
  
                                      alt={
                                        title
                                      }
  
                                      className="
                                        w-full
                                        h-full
  
                                        object-cover
                                      "
                                    />
  
                                  ) : (
  
                                    <div
                                      className="
                                        flex
  
                                        w-full
                                        h-full
  
                                        items-center
                                        justify-center
  
                                        text-color-1
                                      "
                                    >
                                      <FaUtensils />
                                    </div>
  
                                  )}
  
                                </div>
  
  
                                <div
                                  className="
                                    flex-1
                                    min-w-0
                                  "
                                >
  
                                  <div
                                    className="
                                      flex
                                      justify-between
  
                                      gap-3
                                    "
                                  >
                                    <h3
                                      className="
                                        font-kufi
                                        text-sm
  
                                        line-clamp-2
                                      "
                                    >
                                      {
                                        title
                                      }
                                    </h3>
  
  
                                    <span
                                      className="
                                        shrink-0
  
                                        font-bold
  
                                        text-color-1
                                      "
                                    >
                                      {
                                        lineTotal
                                      }
                                    </span>
                                  </div>
  
  
                                  <div
                                    className="
                                      flex
                                      items-center
  
                                      gap-2
  
                                      mt-2
                                    "
                                  >
                                    <FaUtensils
                                      className="
                                        text-color-1
                                        text-[10px]
                                      "
                                    />
  
                                    <span
                                      className="
                                        font-kufi
                                        text-[10px]
  
                                        text-white/50
                                      "
                                    >
                                      {
                                        quantity
                                      }{" "}
                                      ×{" "}
                                      {
                                        price
                                      }{" "}
                                      {t(
                                        "currency"
                                      )}
                                    </span>
                                  </div>
  
                                </div>
  
                              </div>
  
  
                              {item.notes &&
                                item.notes.trim() && (
  
                                <div
                                  className="
                                    mt-3
  
                                    rounded-xl
  
                                    bg-white/5
  
                                    px-3
                                    py-2
                                  "
                                >
                                  <span
                                    className="
                                      block
  
                                      font-kufi
                                      text-[9px]
  
                                      text-color-1
  
                                      mb-1
                                    "
                                  >
                                    {t(
                                      "notes"
                                    )}
                                  </span>
  
                                  <p
                                    className="
                                      font-kufi
                                      text-[10px]
  
                                      text-white/60
  
                                      leading-5
                                    "
                                  >
                                    {
                                      item.notes
                                    }
                                  </p>
                                </div>
  
                              )}
  
                            </div>
                          );
                        }
                      )}
  
                    </div>
  
  
                    {/* TOTAL */}
  
                    <div
                      className="
                        mt-6
  
                        pt-5
  
                        border-t
                        border-white/10
                      "
                    >
  
                      <div
                        className="
                          flex
                          justify-between
  
                          mb-4
                        "
                      >
                        <span
                          className="
                            font-kufi
                            text-xs
  
                            text-white/50
                          "
                        >
                          {t(
                            "total quantity"
                          )}
                        </span>
  
  
                        <span>
                          {
                            totalQuantity
                          }
                        </span>
                      </div>
  
  
                      <div
                        className="
                          flex
                          items-end
                          justify-between
  
                          pt-4
  
                          border-t
                          border-white/10
                        "
                      >
  
                        <span
                          className="
                            font-kufi
                            text-sm
  
                            text-white/70
                          "
                        >
                          {t(
                            "order total"
                          )}
                        </span>
  
  
                        <div
                          className="
                            flex
                            items-end
                            gap-1
                          "
                        >
                          <span
                            className="
                              text-3xl
                              md:text-4xl
  
                              font-bold
  
                              text-color-1
                            "
                          >
                            {
                              orderTotal
                            }
                          </span>
  
  
                          <span
                            className="
                              font-kufi
                              text-xs
  
                              mb-1
                            "
                          >
                            {t(
                              "currency"
                            )}
                          </span>
                        </div>
  
                      </div>
  
                    </div>
  
                  </div>
  
                </div>
  
  
                {/* Add More */}
  
                <Link
                  to="/AllResturentMeals"
  
                  className="
                    group
  
                    mt-4
  
                    flex
  
                    w-full
  
                    items-center
                    justify-center
  
                    gap-2
  
                    rounded-full
  
                    border
                    border-color-2/10
                    dark:border-white/10
  
                    bg-back-primery
                    dark:bg-back-darksecondary
  
                    px-5
                    py-4
  
                    font-kufi
                    text-sm
  
                    text-tcolor-4
                    dark:text-white
  
                    transition-all
  
                    hover:border-color-1
                    hover:text-color-1
                  "
                >
                  <FiEdit3 />
  
                  {t(
                    "add more meals"
                  )}
                </Link>
  
              </motion.aside>
  
            </div>
  
          </div>
  
        </main>
  
  
        <Fotter />
      </>
    );
  }
  
  
  /* =====================================
      INPUT
  ====================================== */
  
  function CheckoutInput({
    icon: Icon,
    label,
    error,
    ...props
  }) {
  
    return (
      <div
        className="
          mb-6
        "
      >
  
        <label
          htmlFor={
            props.name
          }
  
          className="
            flex
            items-center
  
            gap-2
  
            mb-2
  
            font-kufi
            font-semibold
  
            text-sm
  
            text-tcolor-4
            dark:text-white
          "
        >
  
          <Icon
            className="
              text-color-1
            "
          />
  
          {label}
  
        </label>
  
  
        <input
          id={
            props.name
          }
  
          {...props}
  
          className={`
            w-full
  
            min-h-[56px]
  
            rounded-[1.25rem]
  
            border
  
            bg-back-secondary
            dark:bg-back-darkprimery
  
            px-4
            py-4
  
            font-kufi
            text-base
  
            text-tcolor-4
            dark:text-white
  
            placeholder:text-n-4
  
            outline-none
  
            transition-all
  
            ${
              error
                ? `
                  border-red-400
                `
                : `
                  border-color-2/10
                  dark:border-white/10
  
                  focus:border-color-1
                  focus:ring-2
                  focus:ring-color-1/10
                `
            }
          `}
        />
  
  
        {error && (
  
          <motion.p
            initial={{
              opacity: 0,
              y: -3,
            }}
  
            animate={{
              opacity: 1,
              y: 0,
            }}
  
            className="
              mt-2
  
              font-kufi
              text-xs
  
              text-red-500
            "
          >
            {error}
          </motion.p>
  
        )}
  
      </div>
    );
  }
  
  
  export default Checkout;